import React from 'react'
import Auth from '../auth/Auth'
import { useSelector } from 'react-redux'

export default function PrivateLayout() {

    return (
        <>
            <Auth />
        </>
    )
}
